import {register} from '@shopify/theme-sections';

const sectionType = 'page-contact-selector';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

const selectors = {
  contactDropdown: '[data-contact-dropdown]',
  selectedContact: '[data-selected-contact]',
};

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const contactDropdown = this.container.querySelector(selectors.contactDropdown);
      const selectedContact = this.container.querySelector(selectors.selectedContact);

      if (!contactDropdown || !selectedContact) return;

      contactDropdown.addEventListener('change', () => {
        selectedContact.textContent = contactDropdown.value;
        selectedContact.href = `mailto:${contactDropdown.value}`;
      });
    },
  });
